export default {"src":"/_next/static/image/public/images/ic_payLater.32908754fe4d9ea18539fbaadc7ad7cb.svg","height":20,"width":28};